import * as React from "react";
import {useRef } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { CustomDropdown } from "./customDropdown";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { dropdownService } from "../../services/api/dropdown.service";
import { partnerService } from "../../services/api/partner.service"; 

export const ParamSelection = ({ runRaport, visible, toggleDialog, title, haveLocation }) => {

    const formRef = useRef();
    const partener = sessionStorage.getItem("idPartener");


    const handleRunRap = (type) => {

        let formValues = formRef.current?.values ?? {};


        let data = {
            partener: formValues.partener?.id ?? 0,
            deladata: formValues.deladata?.toDateString() ?? null,
            ladata: formValues.ladata?.toDateString() ?? null
        }

        if (haveLocation) {
            data.locatie = formValues.locatie?.id ?? 0;
        }
        runRaport(title, type, data);
    }



    return (
        <> {
            visible &&
            < Dialog title={"Parametri " + title} onClose={toggleDialog}>
                    <div style={{ margin: "10px", width: "600px" }}>
                        <Form
                            ref={formRef}
                           
                            render={() => (
                                <FormElement>
                                    
                                        <Field
                                            component={CustomDropdown}
                                            className="w250"
                                            type="text"
                                            name="partener"
                                            label="Partener"
                                            request={dropdownService.getPartners}
                                            setFirstValue={ true}
                                        />
                                    

                                    { haveLocation &&
                                             <Field
                                                component={CustomDropdown}
                                                className="w250"
                                                name="locatie"
                                                label="Locatie"
                                                request={partnerService.getLocations}
                                                setFirstValue={true}
                                            />
                                        
                                    }

                                        <Field
                                            component={DatePicker}
                                            className="w250"
                                            format="dd-MM-yyyy"
                                            name="deladata"
                                            label="De la data"
                                            value={formRef.current?.deladata ?? null}
                                        />

                                   
                                        <Field
                                            component={DatePicker}
                                            className="w250"
                                            format="dd-MM-yyyy"
                                            name="ladata"
                                            label="La data"
                                            value={formRef.current?.ladata ?? null}
                                        />
                               
                                </FormElement>
                            )}
                    />              
                </div>

                <DialogActionsBar>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={() => handleRunRap("PDF")}
                    >
                        Selecteaza
                    </button>
                    <button onClick={toggleDialog} > Iesire</button>

                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={() => handleRunRap("xls")}
                    >
                    XLS</button>

                </DialogActionsBar>
            </Dialog>
        }
        </>
    );
}